<div class="page-container">
  <div>
    <h1>Page Not Found</h1>
    <span>It looks like you have ended up on page that doesn't exist!</span>
  </div>
  <div>
    <button mat-stroked-button color="primary" routerLink="/">Back to Home</button>
  </div>
</div>
